/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Button_SubmittingInputs */

const es_co2_login_button_submitting = /** @type {(inputs: Login_Button_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando sesión…`)
};

/**

* @param {Login_Button_SubmittingInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const login_button_submitting = /** @type {((inputs?: Login_Button_SubmittingInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Button_SubmittingInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_login_button_submitting(inputs)
});